import { useState, useEffect } from "react";
import { FormattedMessage as FM } from "react-intl";
import { signal } from "@preact/signals-react";

import { Column, DataTable } from "./table";

import BasicModal from "components/Modals/BasicModal2";
import WizardAddPayment from "./WizardAddPayment";
import { PlusCircleIcon, PrintIcon, TrashIcon } from "components/Icons";
import useMainStore from "store/mainStore";
import proxy from "api/proxy";
import { Alert } from "components/Tools/Alert";
import printVoucher from "../services/paymentVoucher";

const openModal = signal(false);

const Payment = (props) => {
  const disabled = false;
  const { record } = useMainStore();
  const [payments, setPayments] = useState([]);
  const [otherPayments, setOtherPayments] = useState([]);
  const [selected, setSelected] = useState(null);

  const [alert, setAlert] = useState(false);
  const saleId = record.id;

  function handlePrintVoucher() {
    if (selected) {
      printVoucher(selected);
    }
  }

  async function getPayments() {
    const fields = [
      "payments.amount",
      "payments.date",
      "payments.statement",
      "payments.statement.state",
      "payments.statement.rec_name",
      "payments.description",
      "payments.sale",
      "other_payments.amount",
      "other_payments.statement",
      "other_payments.statement.state",
      "other_payments.description",
      "other_payments.origin.rec_name",
    ];
    const { data } = await proxy.browse("sale.sale", [saleId], fields);
    if (data) {
      setPayments(data[0]["payments."]);
      setOtherPayments(data[0]["other_payments."]);
    }
  }

  useEffect(() => {
    getPayments();
  }, []);

  function handlePayment() {
    openModal.value = true;
  }

  async function handleDeletePayment(record, model) {
    if (record["statement."]?.state === "draft") {
      await proxy.remove({
        model: model,
        ids: [record.id],
      });
      await getPayments();
    } else {
      setAlert(true);
    }
  }

  async function onCloseModal() {
    openModal.value = false;
    await getPayments();
  }

  return (
    <>
      <div className="m-4">
        <Alert
          autoRemove={true}
          show={alert}
          onClose={() => setAlert(false)}
          duration={3000}
          text={"dont_delete_payment_line"}
        />
      </div>

      <div className="flex flex-col items-center justify-center p-4 bg-slate-50 rounded-md overflow-auto">
        <div className="w-full flex justify-end mb-2 space-x-4">
          <button
            type="button"
            onClick={handlePrintVoucher}
            title="Imprime comprobantes seleccionados"
            className="flex items-center h-fit text-lg font-medium px-4 space-x-2 py-1 rounded-md shadow-md transform duration-75 bg-gray-800 text-white hover:bg-gray-700 active:scale-90 disabled:bg-gray-300 disabled:text-gray-600 disabled:cursor-not-allowed disabled:shadow-none"
          >
            <span>
              <FM id="statement.line.print_voucher" />
            </span>
            <PrintIcon className="text-white w-6 fill-current" />
          </button>

          <button
            type="button"
            disabled={disabled}
            className="flex bg-cyan-500 text-white items-center h-fit text-lg font-medium hover:bg-cyan-400 active:scale-90 px-4 space-x-2 py-1 rounded-md shadow-md transform duration-75"
            onClick={handlePayment}
          >
            <span>
              <FM id="add_header_modal" />
            </span>

            <PlusCircleIcon className="text-white w-6 fill-current" />
          </button>
        </div>
        {otherPayments.length > 0 && (
          <DataTable
            value={otherPayments}
            className="w-full"
            selectionMode={"multiple"}
            selection={selected}
            onSelectionChange={setSelected}
          >
            <Column field="description" header="Descripcion" />
            <Column field="amount" header="Monto" />
            <Column field="statement.state" header="Estado" />
            <Column
              field="statement.action"
              header="Eliminar"
              body={(record) => (
                <TrashIcon
                  onClick={() =>
                    handleDeletePayment(record, "sale_pos.additional_income")
                  }
                  className="text-white w-6 fill-red-500"
                />
              )}
            />
          </DataTable>
        )}
        {payments.length > 0 && (
          <DataTable
            value={payments}
            className="w-full"
            selectionMode={"multiple"}
            selection={selected}
            onSelectionChange={setSelected}
          >
            <Column field="statement.rec_name" header="Medio de Pago" />
            <Column field="date" header="Fecha" />
            <Column field="description" header="Descripcion" />
            <Column field="amount" header="Monto" />
            <Column field="statement.state" header="Estado" />
            <Column
              field="statement.action"
              header="Eliminar"
              body={(record) => (
                <TrashIcon
                  onClick={() =>
                    handleDeletePayment(record, "account.statement.line")
                  }
                  className="text-white w-6 fill-red-500"
                />
              )}
            />
          </DataTable>
        )}
      </div>

      <BasicModal
        title={"account.statement.line"}
        openModal={openModal}
        closeModal={onCloseModal}
        titleSize="text-2xl"
      >
        <WizardAddPayment onClose={onCloseModal} parentRec={record} />
      </BasicModal>
    </>
  );
};

export default Payment;
